import { useQuery } from 'react-query'
import { getWrongJurisdictionInvoices } from './taxJurisdictionAuditApi'

export const useWrongJurisdictionInvoicesQuery = () => {
  return useQuery(['admin', 'invoicing', 'wrong-jurisdiction-invoices'], {
    queryFn: getWrongJurisdictionInvoices,
    refetchOnWindowFocus: false,
  })
}
